import React, { useEffect, useState } from "react";
import classes from "./Settings.module.css";
import { AfterLoginHeader } from "../../../stories/AfterLoginHeader/AfterLoginHeader";
import Fonts from "../../../stories/assets/Fonts";
import Colors from "../../../stories/assets/Colors";
import { Col, Container, Row } from "react-bootstrap";
import { isMobileViewHook } from "../../../CustomHooks/isMobileViewHook";
import { Footer } from "../../../stories/Footer/Footer";
import { Tabs } from "../../../stories/Tabs/Tabs";
import PersonalInfo from "./PersonalInfo/PersonalInfo";
import PayoutMethod from "./PayoutMethod/PayoutMethod";
import Notifications from "./Notifications/Notifications";
import SettingsMobile from "./SettingsMobile";

const SettingsDesktop = () => {
  const [activeTab, setActiveTab] = useState({ label: "Personal Info" });
  const tabsData = [
    { label: "Personal Info" },
    { label: "Payment methods" },
    { label: "Notifications" },
  ];
  const onClickSearch = (data) => {
    console.log(data);
  };

  const handleSearch = (data) => {
    console.log(data);
  };
  return (
    <Row className={`g-0 ${classes.row}`}>
      <div
        className={[classes.headerDiv]}
        style={{
          borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}`,
          backgroundColor: Colors.white,
        }}
      >
        <AfterLoginHeader
          onClickSearch={onClickSearch}
          showSearch={true}
          onSubmitSearch={handleSearch}
          customStyle={{ padding: "0px" }}
        />
      </div>
      <Col md={12}>
        <Container fluid className={[classes.mainContainer]}>
          <h3 style={{ color: Colors.neutralShadesOfNero, ...Fonts.h3 }}>
            Account settings
          </h3>
          <div className={[classes.tabsDiv]}>
            <Tabs
              state={activeTab}
              setState={setActiveTab}
              tabsData={tabsData}
            />
          </div>

          {activeTab.label === "Personal Info" && <PersonalInfo />}
          {activeTab.label === "Payment methods" && <PayoutMethod />}
          {activeTab.label === "Notifications" && <Notifications />}
        </Container>
      </Col>
      <Col md={12} style={{ alignSelf: "flex-end" }}>
        <Footer className={classes.container} />
      </Col>
    </Row>
  );
};

const Settings = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  return isMobile ? <SettingsMobile /> : <SettingsDesktop />;
};
export default Settings;
